const EntityType = {
  donor: "DONOR",
  distributor: "DISTRIBUTOR",
  donorDistributor: "DONOR_DISTRIBUTOR",
  specialDistributor: "SPECIAL_DISTRIBUTOR",
};

const EntityFavoriteStatus = {
  favorite: "FAVORITE",
  blacklisted: "BLACKLISTED",
};

const UserType = {
  individualUser: "INDIVIDUAL_USER",
  entity: "ENTITY",
  gppAdmin: "GPP_ADMIN",
  entityManager: "ENTITY_MANAGER",
};

const RegistrationStatus = {
  registering: "REGISTERING",
  pendingEmailVerification: "PENDING_EMAIL_VERIFICATION",
  pendingApproval: "PENDING_APPROVAL",
  invited: "INVITED",
  rejected: "REJECTED",
  active: "ACTIVE",
  inActive: "IN_ACTIVE",
  revoked: "REVOKED",
  inAtivo:"inativo"
};

const DocumentStatus = {
  invalid: "INVALID",
  waitingForValidation: "WAITING_FOR_VALIDATION",
  valid: "VALID",
  expired: "EXPIRED",
};

const FileType = {
  businessRegistration: "BUSINESS_REGISTRATION",
  mandatedStatement: "MANDATED_STATEMENT",
};

const RegistrationPortugeseStatus = {
  //REGISTERING: "A registar",
  //PENDING_EMAIL_VERIFICATION: "Verificação de e-mail pendente",
 // PENDING_APPROVAL: "Aprovação pendente",
  ACTIVE: "Ativo",
  IN_ACTIVE: "Inativo",
  REJECTED: "Rejeitado",
};

const RegistrationPortugeseStatus2 = {
  ACTIVE: "Ativo",
  IN_ACTIVE: "Inativo",
  INVITED: "Convidado",
};

const RegistrationPortugeseStatusPendingRegister = {
  REGISTERING: "A registar",
  PENDING_EMAIL_VERIFICATION: "Verificação de e-mail pendente",
}

const DonationStatus = {
  creating: "CREATING",
  new: "NEW",
  publish: "PUBLISHED",
  cancel: "CANCELLED",
  reserved: "RESERVED",
  delivered: "DELIVERED",
  expired: "EXPIRED",
  partial: "PARTIAL",
  reservation: "RESERVATION",
  isHistory: "ISHISTORY",
  collected: "COLLECTED",
};

const CollectionStatus = {
  creating: "CREATING",
  reserved: "RESERVED",
  pending: "PENDING",
  collected: "COLLECTED",
  cancelled: "CANCELLED",
  delivered: "DELIVERED",
  expired: "EXPIRED",
};

const areaOfActivity = {
  feedBank: "FEED_BANK",
  horecaChannel: "HORECA_CHANNEL",
  publicEntities: "PUBLIC_ENTITIES",
  industry: "INDUSTRY",
  ipss: "IPSS",
  production: "PRODUCTION",
  retailer: "RETAILER",
  restaurants: "RESTAUARANTS",
  hotel: "HOTEL",
  catering: "CATERING",
  other: "OTHER",
  kennel: "KENNEL_CATTERY",
  zoo: "ZOO",
  others: "OTHERS",
};

const EntityTypeQuestion = {
  groupUnitManangement: "groupUnitManangement",
  store: "store",
};

const units = ["unit","box","litre" ,"kg" ];

const ComponentType = {
  DONATION: "donation",
  AGENDA: "agenda",
  ADMIN_VIEW: "adminVew",
  ORGANIZATIONS: "organizations",
  IDENTIFICATION_TYPE: "addBranch",
  MANAGE_MANGERS: "manageManagers",
  PRODUCT: "product",
  CART_PRODUCT: "cartProduct",
  DASHBOARD_STATS: "stats",
  DONATION_VIEW: "donationView",
  AGENDA_PRODUCT: "agendaProduct",
  DISTRIBUTOR_DONATION_PRODUCT: "distrbibutorDonationProduct",
  HEADER: "header",
  LOG_IN: "login",
  DONATION_HEADER: "donationHeader",
  DONATION_CARD: "donationCard",
};

const CollectionType = {
  DONATED: "donated",
  COLLECTION: "collection",
};

const OrganizationTab = {
  PENDING: "pending",
  ALL: "all",
};

const SupportEmail = "suporte@tomaladaca.gov.pt";

const identificationType = true;

const DEFAULT_COVER_URL =
  "/static/illustrations/illustration_default_banner.jpg";
const DEFAULT_AVATAR_URL =
  "/static/illustrations/illustration_defaultavatar.png";

export {
  EntityType,
  UserType,
  RegistrationStatus,
  DonationStatus,
  areaOfActivity,
  units,
  CollectionStatus,
  ComponentType,
  CollectionType,
  SupportEmail,
  OrganizationTab,
  EntityTypeQuestion,
  RegistrationPortugeseStatus,
  RegistrationPortugeseStatus2,
  RegistrationPortugeseStatusPendingRegister,
  DEFAULT_COVER_URL,
  DEFAULT_AVATAR_URL,
  DocumentStatus,
  FileType,
  EntityFavoriteStatus,
};
